export default '/static/frontend/ReachDigital/12gobiking/dist/assets/ups-308bf428.svg'